import React from "react";
import TestsPageTemplate from "../components/TestsPageTemplate";
import {TEST_TYPES} from "../../../../shared/types/testTypes";

const TestsEvaluation = () => {

    return (
        <TestsPageTemplate
            config={TEST_TYPES.evaluate}
        />
    );
};

export default TestsEvaluation;
